import { useState } from 'react'
import { getAPIURL } from '../../GlobalComponents/URLs'

interface FetchPermissionsParams {
    Company: string
    Username: string
    Domain: string
    Ability: string
}

export interface Tag {
    CreatedDate: string
    CustomerAssetType: number
    OriginalCustomerAccountCode: string
    SerialNumber: string
    Tag: string
    TagUID: number
}

export interface Asset {
    AssetTypeID: number
    AssetTypeName: string
    AssetTypeOrderBy: number
    CategoryID: number
    CategoryName: string
    CategoryOrderBy: number
}

export interface AssetCategory {
    ID: number
    Name: string
    OrderBy: number
}

export interface AssetType {
    CustomerAssetCategoryID: number
    ID: number
    Name: string
    OrderBy: number
}

export interface ServiceType {
    ServiceTypeID: string
    ServiceDescription: string
    OrderBy: number
}

export interface SendDocumentationEmailPayload {
    TagUID: number
    Email: string
}

export async function fetchPermissions(payload: FetchPermissionsParams) {
    let url = getAPIURL() + 'master/GetUserPermissions'

    let req = await fetch(url, {
        credentials: 'include',
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
    })

    let json = await req.json()
    return json
}

export async function fetchAssetByAssetId(id: number) {
    let url = getAPIURL() + `Form/asset/ByAssetId/${id}`

    let req = await fetch(url, {
        credentials: 'include',
        method: 'GET',
        headers: { 'Content-type': 'application/json' },
    })

    let json: Asset[] = await req.json()
    return json[0]
}

export async function fetchAssetCategories() {
    let url = getAPIURL() + 'Form/asset/categories'

    let req = await fetch(url, {
        credentials: 'include',
        method: 'GET',
        headers: { 'Content-type': 'application/json' },
    })

    let json: AssetCategory[] = await req.json()
    return json
}

export async function fetchAssetTypes(id: number) {
    let url = getAPIURL() + `Form/asset/types/${id}`

    let req = await fetch(url, {
        credentials: 'include',
        method: 'GET',
        headers: { 'Content-type': 'application/json' },
    })

    let json: AssetType[] = await req.json()
    return json
}

export async function fetchServiceTypes() {
    let url = getAPIURL() + 'Form/asset/service/types'

    let req = await fetch(url, {
        credentials: 'include',
        method: 'GET',
        headers: { 'Content-type': 'application/json' },
    })

    let json: ServiceType[] = await req.json()
    return json
}

export async function fetchTagMaster(tagUID: number) {
    let tag_url = getAPIURL() + 'Form/TagMaster'

    let req = await fetch(tag_url, {
        credentials: 'include',
        method: 'POST',
        headers: { 'Content-type': 'application/json' },
        body: JSON.stringify({
            tagUID: tagUID,
        }),
    })

    if (req.status === 400) {
        return null
    }

    let json: Tag[] = await req.json()
    return json[0]
}

export async function fetchUpdateTagMasterAssetType(allTagUIDs: number[], id: number) {
    let url = getAPIURL() + 'Form/UpdateTagMasterAssetType'

    let req = await fetch(url, {
        credentials: 'include',
        method: 'POST',
        headers: { 'Content-type': 'application/json' },
        body: JSON.stringify({
            tagUIDs: allTagUIDs,
            newAssetTypeId: id,
        }),
    })

    if (req.status.toString().startsWith('4')) {
        return false
    }
    if (req.status.toString().startsWith('2')) {
        return true
    }
}

export async function fetchSendDocumentation(payload: SendDocumentationEmailPayload) {
    let url = getAPIURL() + 'lcm/SendDocumentation'
    let error = ''

    const req = await fetch(url, {
        credentials: 'include',
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
    })

    if (!req.ok) {
        error = await req.text()
    }

    return error
}
